import { render, staticRenderFns } from "./estproForm.vue?vue&type=template&id=3520e040&scoped=true"
import script from "./estproForm.vue?vue&type=script&lang=js"
export * from "./estproForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520e040",
  null
  
)

export default component.exports